export default "__VITE_ASSET__C00sggGH__"